import Footer from "../global/components/Footer";
import Header from "../global/components/Header";
import { AuthenticationProvider } from "../global/contexts/AuthenticationContext";
import { UserInfoProvider } from "../global/contexts/UserInfoContext";
import { LearningLanding } from "./components/LearningLanding";
import { LearningProvider } from "./contexts/LearningContext";

//This component sets up the Aap Learning application by calling the Header,
//AuthenticationProvider, UserInfoProvider, LearningProvider, LearningLanding, and Footer components.
export default function AapLearningApp() {
    return (
        <>
            <Header message={"AAP Learning"} />
                <AuthenticationProvider>
                    <UserInfoProvider>
                        <LearningProvider>
                            <LearningLanding />
                        </LearningProvider>
                    </UserInfoProvider>
                </AuthenticationProvider>
            <Footer />
        </>
    );
}